<template><time v-if="value" :datetime="iso" :title="absolute" :aria-label="absolute">{{ relative }}</time><span v-else>Fecha no disponible</span></template>
<script>
export default {
  name: 'ForumDate', props: { value: Number, locale: { type: String, default: 'es-ES' } },
  computed: {
    iso() { return new Date(this.value).toISOString(); },
    absolute() { return new Intl.DateTimeFormat(this.locale, { dateStyle: 'long', timeStyle: 'short' }).format(this.value); },
    relative() {
      const seconds = Math.round((this.value - Date.now()) / 1000);
      const [unit, divisor] = Math.abs(seconds) < 3600 ? ['minute', 60] : Math.abs(seconds) < 86400 ? ['hour', 3600] : ['day', 86400];
      if (Math.abs(seconds) > 604800) return new Intl.DateTimeFormat(this.locale, { day: 'numeric', month: 'short', year: 'numeric' }).format(this.value);
      return new Intl.RelativeTimeFormat(this.locale, { numeric: 'auto' }).format(Math.round(seconds / divisor), unit);
    }
  }
};
</script>
